module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter",
      "id": "apt1",
      "title": "SECTION 1: MASTER YOUR DSLR"
    }
  }, [_c('p', {
    staticClass: "ptno"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#pt1"
    }
  }, [_vm._v("SECTION 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "pttitle"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#pt1"
    }
  }, [_vm._v("Master Your DSLR")])]), _vm._v(" "), _c('p', {
    staticClass: "pttitles"
  }, [_c('span', {
    staticClass: "gr"
  }, [_vm._v("Specific Techniques for Getting the Most from Your Camera")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_vm._v("Photography is truly magical. And I’m certainly not alone in thinking so. Millions of people around the world take photographs with a wide range of cameras, from cell phones to large-view cameras. In this section, I will present specific tips and techniques for understanding and using many of the creative tools that can be found on all DSLR and mirrorless cameras, as well as many advanced compact cameras.")]), _vm._v(" "), _c('p', {
    staticClass: "subheadinga"
  }, [_c('span', {
    staticClass: "bl"
  }, [_vm._v("DIGITAL CAMERA TYPES")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_vm._v("Digital cameras are sold in four main configurations: digital single-lens reflex cameras (DSLRs), mirrorless interchangeable lens cameras (MILCs), compact fixed-lens mirrorless cameras and digital rangefinder cameras. Digital rangefinder cameras are also mirrorless, but have some distinct differences.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The main difference between DSLRs and the three mirrorless camera types mentioned is that every DSLR contains an optical viewfinder that works in tandem with a mirror that’s positioned at an angle inside the camera and behind the lens. This allows you to see through the lens while focusing and composing photographs. During an exposure, the mirror flips up and out of the way. There is also often a button you can press to see a depth-of-field preview, which gives you a preview of the sharpness in different parts of the scene.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "Fig. 0.1 A Canon ...",
      "height": "269",
      "src": "images/f0007-01.jpg",
      "width": "355"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "ch0fig1"
    }
  }, [_c('b', [_vm._v("Fig. 0.1")]), _vm._v(" A Canon EOS 6D (left), Canon Rebel T4i (right) and a Panasonic Lumix DMC-LX5 (bottom).")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In the three mirrorless cameras types, there is, as you may have guessed, no mirror. Instead, in almost all cases, a video image created by the image on the camera’s sensor is sent in near real-time to an electronic viewfinder (EVF) located in the back top area of the camera, which allows the viewer to see an image prior to the shot being taken that approximates the final image (assuming no flash, or strobe, is being used).")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Fig. 0.2 An Olympus ...",
      "height": "269",
      "src": "images/f0008-01.jpg",
      "width": "355"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "ch0fig2"
    }
  }, [_c('b', [_vm._v("Fig. 0.2")]), _vm._v(" An Olympus PEN E-P2 with an Olympus Electronic Viewfinder VF-2 and an LCD Loupe.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("A fixed-lens camera means that you cannot change the camera’s lens, but you can often add screw-on accessories such as close-up lenses or telephoto lenses. Some mirrorless cameras have no viewfinder at all, like the Panasonic Lumix DMC-LX5 ("), _c('a', {
    attrs: {
      "href": "#/text/Part001#ch0fig1"
    }
  }, [_vm._v("fig. 0.1")]), _vm._v("); you just rely on the camera’s LCD screen, much like you would with a smartphone. Some mirrorless cameras, like the Olympus PEN E-P2, shown in "), _c('a', {
    attrs: {
      "href": "#/text/Part001#ch0fig2"
    }
  }, [_vm._v("fig. 0.2")]), _vm._v(" with an Olympus Electronic Viewfinder VF-2, offer optional viewfinders. One negative with that option is that the camera’s hot shoe (the slot on top of many cameras usually reserved for shoe-mount flash units) will generally be used for that, making it impossible to use a shoe-mount flash at the same time in that location.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Digital rangefinder cameras differ from DSLRs primarily due to the way you compose and focus the scene. You view the scene through an optical viewfinder and line up two images until they overlap. There are some advantages and disadvantages to digital rangefinders. The greatest advantage is that their lenses (especially wide to medium focal length lenses) tend to be smaller and lighter than DSLR lenses (especially full-frame lenses).")]), _vm._v(" "), _c('p', {
    staticClass: "imagel1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/lineb.jpg",
      "width": "771"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normalb"
  }, [_c('span', {
    staticClass: "bl"
  }, [_c('b', [_vm._v("FLASH OPTIONS")]), _vm._v("—Electronic flash is truly an incredible invention, and many cameras have built-in flash units. They do have some limitations, but with a bit of practice, you might be surprised at how they can affect the quality of your photographs. I cover this topic in "), _c('span', {
    attrs: {
      "href": "#/text/Chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tip 33")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/text/Chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tip 34")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/lineb.jpg",
      "width": "771"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_vm._v("The main negative with digital rangefinders is that the image you see in the optical viewfinder is almost never the same (as far as the coverage of the scene, or field of view) as compared with a DSLR or mirrorless camera with an EVF or live view capability. In fact, the image’s field of view can be extremely off with very wide lenses and telephoto lenses.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In some cases, digital rangefinder cameras can use live view as described above via the LCD or an accessory EVF. Pictured in "), _c('a', {
    attrs: {
      "href": "#/text/Part001#ch0fig3"
    }
  }, [_vm._v("fig. 0.3")]), _vm._v(", Leica M is an example of a digital rangefinder camera that has live view functionality via the LCD or with an accessory EVF. You can find additional details on rangefinders and specific digital rangefinder cameras, at "), _c('a', {
    attrs: {
      "href": "http://www.camera-wiki.org",
      "target": "_blank"
    }
  }, [_vm._v("www.camera-wiki.org")]), _vm._v(", “The Leica Mystique” article at "), _c('a', {
    attrs: {
      "href": "http://www.blogarithms.com/2013/10/01/leica",
      "target": "_blank"
    }
  }, [_vm._v("www.blogarithms.com/2013/10/01/leica")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://www.thisweekinphoto.com/category/gear-episodes",
      "target": "_blank"
    }
  }, [_vm._v("www.thisweekinphoto.com/category/gear-episodes")]), _vm._v(".")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Fig. 0.3 Leica M ...",
      "height": "269",
      "src": "images/f0009-01.jpg",
      "width": "356"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "ch0fig3"
    }
  }, [_c('b', [_vm._v("Fig. 0.3")]), _vm._v(" Leica M is an example of a digital rangefinder.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("A number of companies offer external EVFs and small monitors for DSLRs. These are especially popular with videographers, but they can be very useful for still photography (especially when bright sun makes it difficult to see your images on the LCD). Some DSLRs and compact mirrorless cameras also have touch-screen controls, which can be useful for changing camera settings, and especially for video (you can just touch the spot you want to focus on, as long as your camera/lens combination supports the ability to adjust focus in that manner). Touch-screen controls also usually allow image pinch, zoom and swipe for photo review, like on smartphones.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("There is a lot of additional information available online that explains different digital camera types. "), _c('a', {
    attrs: {
      "href": "http://Wikipedia.org",
      "target": "_blank"
    }
  }, [_vm._v("Wikipedia.org")]), _vm._v(" is one good source and "), _c('a', {
    attrs: {
      "href": "http://kenrockwell.com",
      "target": "_blank"
    }
  }, [_vm._v("kenrockwell.com")]), _vm._v(" is another excellent option. A Google search for “digital camera types” will bring up these and other resources.")]), _vm._v(" "), _c('p', {
    staticClass: "imagel1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/lineb.jpg",
      "width": "771"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxtitle"
  }, [_c('span', {
    staticClass: "bl"
  }, [_vm._v("Reflective Light Meters and Gray T-Shirts")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb"
  }, [_c('span', {
    staticClass: "bl"
  }, [_vm._v("Virtually all modern digital cameras have a reflective light meter inside. All reflective light meters measure the light reflecting off the subjects in the scene, and they basically see the world as being covered with a big medium-gray T-shirt as a baseline with which to work. Once you know that, you can make appropriate adjustments in the exposure based on what’s really in front of you. If you’ve ever seen or used an incident light meter (they are common on Hollywood sets and fashion shoots), it works by measuring the actual light falling on it in the exact place where it is held, so it does not see the world as wearing a big gray T-shirt.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-l2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/lineb.jpg",
      "width": "771"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subheadinga"
  }, [_c('span', {
    staticClass: "bl"
  }, [_vm._v("PRIMARY CAMERA MODES")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_vm._v("Before I go into the main features for controlling exposure with the above camera types in the first few tips, picture yourself outside on a sunny day with a DSLR or mirrorless camera. Depending on the combination of aperture, shutter speed and ISO settings you use, you can create a photo that is completely white (overexposed), very dark (underexposed) or properly exposed (the image looks similar to the way your eyes perceive the scene). And even when your photo is properly exposed, there are many combinations of aperture, shutter speed and ISO that can create that image. It’s a bit like adding three numbers to get to 10. There are many different possible combinations to get to 10. In addition to DSLRs and mirrorless cameras, many other cameras today have advanced features, including Aperture Priority, Shutter Priority, Manual mode and/or Auto ISO. "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001"
    }
  }, [_vm._v("Tip 1")]), _vm._v(" to "), _c('a', {
    attrs: {
      "href": "#/text/Chapter004"
    }
  }, [_vm._v("Tip 4")]), _vm._v(" tackle all of these features, with some assignments that should help you to start making photos instead of just taking them. You will also find suggestions to use one or more of these modes throughout the book depending on the topic I’m covering.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("These modes can either be found on a camera dial (on larger, more advanced cameras) or via an internal menu (many smaller cameras).")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('b', [_vm._v("APERTURE PRIORITY MODE")]), _vm._v("—Discussed in "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001"
    }
  }, [_vm._v("Tip 1")]), _vm._v(" (page 11) and "), _c('a', {
    attrs: {
      "href": "#/text/Chapter002"
    }
  }, [_vm._v("Tip 2")]), _vm._v(" (page 15), this setting allows you to select a specific aperture and the camera automatically adjusts the shutter speed (and sometimes the ISO, if your camera has an Auto ISO option, which I cover in "), _c('a', {
    attrs: {
      "href": "#/text/Chapter004"
    }
  }, [_vm._v("Tip 4")]), _vm._v(", page 22).")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("SHUTTER PRIORITY MODE")]), _vm._v("—Discussed in "), _c('a', {
    attrs: {
      "href": "#/text/Chapter003"
    }
  }, [_vm._v("Tip 3")]), _vm._v(" (page 18), Shutter Priority is a feature that allows you to choose a specific shutter speed. The camera’s aperture is then set for you automatically based on what the camera meter thinks is the proper exposure.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("MANUAL MODE")]), _vm._v("—This mode, discussed in "), _c('a', {
    attrs: {
      "href": "#/text/Chapter004"
    }
  }, [_vm._v("Tip 4")]), _vm._v(" (page 22), allows you to set the aperture, shutter speed, ISO and other settings manually.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a5cd44e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Part001.vue
// module id = 75
// module chunks = 0